<!-- Password Strength Bar -->
<div class="mt-2" *ngIf="password">
  <div class="h-1.5 w-full bg-gray-200 rounded-full overflow-hidden">
    <div
      class="h-full transition-all duration-300 rounded-full"
      [ngClass]="strengthColor"
      [style.width.%]="strengthPercentage">
    </div>
  </div>
</div>
